<f-chart
  [view]="view"
  [xScale]="xScale"
  [yScale]="yScale"
  [animation]="animation"
  [integerYAxis]="integerYAxis"
  [fitContainer]="fitContainer"
  [truncateXAxisTicks]="truncateXAxisTicks"
  [truncateYAxisTicks]="truncateYAxisTicks"
  [rotateXAxisTicks]="rotateXAxisTicks"
  [maxXAxisTickLength]="maxXAxisTickLength"
  [maxYAxisTickLength]="maxYAxisTickLength"
  [maxYAxisTicksCount]="maxTicksCount"
  [xAxisTickFormatting]="xAxisTickFormatting"
  [yAxisTickFormatting]="yAxisTickFormatting"
  [showXAxisGridlines]="showXAxisGridlines"
  [showYAxisGridlines]="showYAxisGridlines"
  [showXAxisTicksLabels]="showXAxisTicksLabels"
  [showYAxisTicksLabels]="showYAxisTicksLabels"
  [showLineAxisTicksLabels]="showLineAxisTicksLabels"
  [xAxisTickLabelClasses]="xAxisTickLabelClasses"
  [xAxisTickLabelOffset]="xAxisTickLabelOffset"
  [showBarsOptionalData]="showBarsOptionalData"
  [showXAxisDomain]="showXAxisDomain"
  [showYAxisDomain]="showYAxisDomain"
  [popoverTemplate]="popoverTemplate"
  [popoverPlacement]="popoverPlacement"
  [legendOptions]="legendOptions"
  [showLegend]="showLegend"
  [legendRootClass]="legendRootClass"
  [leftAxisLabelText]="leftAxisLabelText"
  [labelsOffset]="labelsOffset"
  [showBorders]="showBorders"
  [showLabels]="showLabels"
  [condensedOnDesktop]="condensedOnDesktop"
  [condensedAxisOnMobile]="condensedAxisOnMobile"
  [chartPatternsTemplate]="chartPatternsTemplate"
  (dimensionsChanged)="onDimensionsChanged($event)"
>
  <svg:g
    *ngIf="dimensions"
    f-stacked-bar-series
    [series]="data"
    [gapBetweenSeries]="gapBetweenSeries"
    [limitedBarMaxWidth]="limitedBarMaxWidth"
    [xScale]="xScale"
    [yScale]="yScale"
    [animation]="animation"
    [condensedOnDesktop]="condensedOnDesktop"
    [dimensions]="dimensions"
    [barClasses]="barClasses"
    [interactions]="interactions"
    [popoverTemplate]="popoverTemplate"
    [popoverPlacement]="popoverPlacement"
    [popoverOpenDelay]="popoverOpenDelay"
    [popoverCssClass]="popoverCssClass"
    [animationDuration]="animationDuration"
    [parentChartComponent]="chartComponent"
    [showOptionalData]="showBarsOptionalData"
    [barBubbleShowZero]="infoBubbleShowZero"
    [barBubbleTextClasses]="infoBubbleTextClasses"
    [barBubbleClasses]="infoBubbleClasses"
    [activeBarIndex]="activeBarIndex"
    (seriesClick)="onStackedBarClick($event)"
    (seriesHover)="onBarHover($event)"
  />
</f-chart>
